module.exports = __webpack_public_path__ + "media/images/youtube_attribution-0b28ac6618399e3027f4fc50db9c0a09.png";